import { useEffect, useRef } from 'react';
import Overlay from 'ol/Overlay';
import interact from 'interactjs';

const DEFAULT_OPTIONS = {
    autoPan: true,
    autoPanAnimation: { duration: 250 },
    positioning: 'bottom-center',
    offset: [0, -10],
};

const useMapOverlay = ({ mapRef, elementId, options, isMapReady }) => {
    const overlayRef = useRef(null);

    useEffect(() => {
        if (!isMapReady || overlayRef.current) return;

        const map = mapRef.current;
        if (!map) return;

        const element = document.getElementById(elementId);
        if (!element) return;

        const overlay = new Overlay({
            ...DEFAULT_OPTIONS,
            ...options,
            element,
        });

        map.addOverlay(overlay);
        overlay.setPosition(undefined);
        overlayRef.current = overlay;

        interact(element).draggable({
            allowFrom: '.draggable-header',
            listeners: {
                move(event) {
                    const target = event.target;
                    const x = (parseFloat(target.getAttribute('data-x')) || 0) + event.dx;
                    const y = (parseFloat(target.getAttribute('data-y')) || 0) + event.dy;
                    target.style.transform = `translate(${x}px, ${y}px)`;
                    target.setAttribute('data-x', x);
                    target.setAttribute('data-y', y);
                },
            },
        });

        return () => {
            if (map && overlayRef.current) {
                map.removeOverlay(overlayRef.current);
            }
            overlay.setPosition(undefined);
            interact(element).unset();
            overlayRef.current = null;
        };
    }, [elementId, isMapReady, mapRef, options]);

    return overlayRef;
};

export default useMapOverlay;
